export default __webpack_public_path__ + "static/media/service3.54faf59e.png";